/** BSC 主网 USDT */
export const USDT_ADDRESS = "0x55d398326f99059fF775485246999027B3197955";

/** FundingUUPS 代理（测试网/主网以部署为准） */
export const FUNDINGUUPS_ADDRESS = "0x604b96502fe574034D96e40A6fd5fD8d5a997128";

export const AAPLBToken_ADDRESS = "0x431a3bee82e2ca41e49895cbece5bb0f76a89b7a";

/** 与合约 WBNB_ADDRESS 一致 */
export const WBNB_ADDRESS = "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c";

/** 认购默认上级（须与链上 initialParent 一致） */
export const INITIAL_PARENT_ADDRESS =
  "0x0af212Ee46aC0560C86EdDa7EED7CAc7F6C44276";

export const FILM_API_BASE = "https://filmapi.mine345.site/openapi/v1/swap";

export const PAY_TOKEN_BY_SYMBOL = {
  AAPLB: AAPLBToken_ADDRESS,
  USDT: USDT_ADDRESS,
  BNB: WBNB_ADDRESS,
};

export const PAY_SYMBOL_BY_ADDRESS = Object.fromEntries(
  Object.entries(PAY_TOKEN_BY_SYMBOL).map(([sym, addr]) => [
    addr.toLowerCase(),
    sym,
  ])
);
